import { render, staticRenderFns } from "./prepressdetail.vue?vue&type=template&id=3a6a5924&"
import script from "./prepressdetail.vue?vue&type=script&lang=js&"
export * from "./prepressdetail.vue?vue&type=script&lang=js&"
import style0 from "./prepressdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports